module.exports = __webpack_public_path__ + "static/img/cooperative_2.66b137e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cooperative_2.png
// module id = Jco/
// module chunks = 1